import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const START_AT = 40;

export default function MusicPlayer() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const audio = new Audio("/music/top-gun-anthem.mp3");
    audio.loop = true;
    audio.volume = 0.5;
    audioRef.current = audio;

    const start = () => {
      if (audio.currentTime < START_AT) audio.currentTime = START_AT;
      audio.play().then(() => setPlaying(true)).catch(() => {});
    };

    start();

    const events = ["pointerdown", "keydown", "touchstart", "scroll"];
    const onFirstInteraction = () => {
      start();
      events.forEach((e) => window.removeEventListener(e, onFirstInteraction));
    };
    events.forEach((e) => window.addEventListener(e, onFirstInteraction, { once: true }));

    return () => {
      events.forEach((e) => window.removeEventListener(e, onFirstInteraction));
      audio.pause();
    };
  }, []);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      if (audio.currentTime < START_AT) audio.currentTime = START_AT;
      audio.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  return (
    <button
      onClick={toggle}
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-panna/90 backdrop-blur border border-sand shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:border-terracotta"
      data-testid="music-toggle"
      aria-label={playing ? "Disattiva musica" : "Attiva musica"}
    >
      {playing ? (
        <Volume2 className="w-5 h-5 text-terracotta" />
      ) : (
        <VolumeX className="w-5 h-5 text-clay" />
      )}
    </button>
  );
}
